<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="row justify-content-center text-center">
    <h2 mat-dialog-content
        [innerHTML]="data.schedule.room_no + ' - ' + data.schedule.course_name + ' - ' +data.schedule.session_name +' ('+data.schedule.start_time+'-'+data.schedule.end_time+') '">
    </h2>
    <h3 [innerHTML]="getFormattedDates()"></h3>
</div>

<mat-card class='light'>
    <mat-table #table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="class_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date </mat-header-cell>
            <mat-cell *matCellDef="let customer"> {{customer.class_date | date}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="day">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Day </mat-header-cell>
            <mat-cell *matCellDef="let customer"> {{customer.day}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let customer"> {{customer.status}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let customer">
                <button mat-icon-button (click)="cancelClass(customer.id)">
                    <mat-icon style="color:red;">delete</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</mat-card>